export const FINANCE_VIEW_AS_SESSION_KEY = 'financeViewAsSessionId';
export const FINANCE_VIEW_AS_EXPIRY_KEY = 'financeViewAsExpiresAt';

export const clearFinanceViewAsSession = () => {
  sessionStorage.removeItem(FINANCE_VIEW_AS_SESSION_KEY);
  sessionStorage.removeItem(FINANCE_VIEW_AS_EXPIRY_KEY);
};
